// Actions
export const LONG_GRASS__GET = 'LONG_GRASS__GET';
export const LONG_GRASS__SUBMIT_DISPUTE = 'LONG_GRASS__SUBMIT_DISPUTE';
// Mutations
export const LONG_GRASS__MUTATE_LONG_GRASS = 'LONG_GRASS__MUTATE_LONG_GRASS';
export const LONG_GRASS__MUTATE_LOADING_STATUS = 'LONG_GRASS__MUTATE_LOADING_STATUS';
export const LONG_GRASS__MUTATE_LONG_GRASS_IMAGES = 'LONG_GRASS__MUTATE_LONG_GRASS_IMAGES';
// Getters
